import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { useForm, Controller } from 'react-hook-form';
import { R as RadioGroup } from './RadioGroup-ZDexyLRv.js';
import { R as RadioButton } from './RadioButton--4-l0gXo.js';
import { P as ProductColorAttributeCode } from './product-_pRduMz7.js';
import { c as classnames } from './index-2586sEvh.js';
import { CoreContext } from './context/index.js';

const ColorSwitcher = ({ product, position, errors, colorSwitherMode = 'click', forceColorSwitcherSpacing = false, onClick, onMouseEnter, onMouseLeave, }) => {
    var _a;
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { data: { siteConfig: { category: { maxSwatches = 99 } = {} }, }, } = useContext(CoreContext);
    const { name } = product;
    const { control } = useForm();
    const colorAttribute = (_a = product.configurable_options) === null || _a === void 0 ? void 0 : _a.find(option => Object.values(ProductColorAttributeCode).includes(option.attribute_code));
    if (!colorAttribute && forceColorSwitcherSpacing)
        return (React.createElement("div", { className: `product-colors-container product-colors-container--spacer ${position}` }));
    if (!Array.isArray(product.configurable_options))
        return null;
    const generateLabelStyle = (optionValue) => {
        var _a;
        const backgroundColor = (_a = optionValue.swatch_data) === null || _a === void 0 ? void 0 : _a.value;
        const isImage = /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(backgroundColor);
        const imageUrl = isImage
            ? `${process.env.NEXT_PUBLIC_GRAPHQL_API_URL.replace('/graphql', '')}/media/attribute/swatch/${backgroundColor}`
            : null;
        return {
            ...(imageUrl
                ? {
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }
                : {}),
            ...(backgroundColor && !imageUrl ? { backgroundColor } : {}),
        };
    };
    const generateLabel = (optionValue, fieldValue) => {
        const { label } = optionValue;
        const colorClass = label.replace(/\s+/g, '-').toLowerCase();
        return (React.createElement("div", { style: generateLabelStyle(optionValue), className: classnames('product-colors-bg', colorClass, {
                active: fieldValue === label,
            }), title: label }));
    };
    if (!colorAttribute || !colorAttribute.values)
        return null;
    const visibleSwatches = colorAttribute.values.slice(0, maxSwatches);
    const hiddenSwatchesCount = colorAttribute.values.length - maxSwatches;
    if (colorSwitherMode === 'click') {
        return (React.createElement("div", { className: `product-colors-container ${position}` },
            React.createElement("div", { className: "radio-group-label" },
                tLabel('colorSelector'),
                ":"),
            React.createElement(Controller, { control: control, name: name, render: ({ field: { value, onChange } }) => (React.createElement(RadioGroup, { name: name, ariaLabel: tLabel('productColors', { product: product.name }), errors: errors },
                    visibleSwatches.map(attribute => (React.createElement(RadioButton, { key: attribute.value_index, name: name, selectedValue: value, optionValue: attribute.label, label: generateLabel(attribute, value), onChange: e => {
                            onChange(e);
                            onClick(attribute.label);
                        }, inputClassName: "sr-only", "data-event-name": "bloc_interact", "data-bloc-name": `${attribute.label}` }))),
                    hiddenSwatchesCount > 0 && (React.createElement("div", { className: "product-colors-bg product-colors-bg-more", title: `+ ${hiddenSwatchesCount}` },
                        "+",
                        hiddenSwatchesCount)))) })));
    }
    return (React.createElement("div", { className: `product-colors-container ${position}` },
        React.createElement("div", { className: "radio-group-label" },
            tLabel('colorSelector'),
            ":"),
        React.createElement("div", { className: "radio-group", "aria-label": tLabel('productColors', { product: product.name }) },
            React.createElement("div", { className: "radio-group-items", ...(colorSwitherMode === 'hover' && {
                    onMouseLeave: () => onMouseLeave(),
                }) },
                visibleSwatches.map(attribute => (React.createElement("div", { key: attribute.value_index, className: "radio-button-container", "data-event-name": "bloc_interact", "data-bloc-name": `${attribute.label}` },
                    React.createElement("div", { className: "psuedo-label" },
                        React.createElement("div", { className: "product-colors-bg", title: attribute.label, style: generateLabelStyle(attribute), ...(colorSwitherMode === 'hover' && {
                                onMouseEnter: () => onMouseEnter(attribute.label),
                            }) }))))),
                hiddenSwatchesCount > 0 && (React.createElement("div", { className: "product-colors-bg product-colors-bg-more", title: `+${hiddenSwatchesCount}` },
                    "+",
                    hiddenSwatchesCount))))));
};

export { ColorSwitcher as C };
//# sourceMappingURL=ColorSwitcher-UbWq37lI.js.map
